import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-p00037-auto-choice',
  templateUrl: './p00037-auto-choice.component.html',
  styleUrls: ['./p00037-auto-choice.component.scss'],
  imports: [
    IonButton,
    IonContent,
    IonFooter,
    IonItem,
    IonLabel,
    IonList,
    TranslatePipe,
  ],
})
export class P00037AutoChoiceComponent {
  private modalController = inject(ModalController);

  @Input() value: number = 0;
  @Input() removeBoost: boolean = false;
  constructor() {}

  async select(value: number) {
    await this.modalController.dismiss({ value: value });
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss();
  }
}
